// extracted by mini-css-extract-plugin
module.exports = {"Kiosk":"Kiosk_Kiosk__3mgOm","Login__btn":"Kiosk_Login__btn__2ztup"};